var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewModalComponent',{ref:"modalNewCustomer",attrs:{"overflowContent":""}},[_c('CustomerForm',{ref:"formCustomer",attrs:{"customerId":0},on:{"created":_vm.createdCustomer,"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }